export const TOEIC_P1 = 1;
export const TOEIC_P2 = 2;
export const TOEIC_P3 = 3;
export const TOEIC_P4 = 4;
export const TOEIC_P5 = 5;
export const TOEIC_P6 = 6;
export const TOEIC_P7 = 7;
export const TOEIC_MINI = 8;
export const TOEIC_FULL = 9;

export const FULL_100 = 1;
export const LISTEN_100 = 2;
export const READ_100 = 3;

export const TOEIC_PARTS = [1, 2, 3, 4, 5, 6, 7];
export const TOEIC_LISTEN_PARTS = [1, 2, 3, 4];
export const TOEIC_READ_PARTS = [5, 6, 7];
export const IELT_WRITE = [1, 2];

export const QUESTION_RADIO = 1;
export const QUESTION_INPUT = 2;
export const QUESTION_OPTION = 3;
export const QUESTION_MULTI = 4;

export const PART_1 = 1;
export const PART_2 = 2;
export const PART_3 = 3;

export const TIME_PENDING_PART_1 = 5;
export const TIME_PENDING_PART_2 = 60;
export const TIME_SPEAK_PART_2 = 2;
export const TIME_SPEAK_PART_1 = 5;

export const PASSAGES_IELT_READ = 3;

export const B1_GRAMMAR = 1;
export const B1_LISTEN = 2;
export const B1_READ = 3;

export const RESET_DATA_TEST = 'RESET_DATA_TEST';
export const SET_TEST_RESULT = 'SET_TEST_RESULT';
export const SET_TEST_PROCESS = 'SET_TEST_PROCESS';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_GROUP_QUESTION = 'SET_GROUP_QUESTION';
export const FETCH_TEST_SUCCESS = 'FETCH_TEST_SUCCESS';
